import nav from './nav'
import home from './home'
import product from './product/index'

const modules = {
	nav, home, product
}
const result = {
	install(Vue) {
		Vue.prototype.$api = {
			dispatch: async (api, param)=>{
				const arr = api.split('.')
				if(arr.length === 2) {
					let method = modules[arr[0]][arr[1]]
					if(method) {
						return method(param)
					}
				}
				return null
			}
		}
	}
}
export default result